import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { SimpleForm } from "@/shared/components/text-box/simple-form";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { usePaymentLoginInfo } from "@/features/accounts/payment/scraping/hooks/use-login-info";
import { PasswordForm } from "@/shared/components/text-box/password-form";
import React, { useEffect } from "react";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { OneTimePassModal } from "@/features/accounts/payment/scraping/components/one-time-pass-modal";
import { useOneTimePassContext } from "@/features/accounts/payment/scraping/contexts/one-time-pass-context";
import { usePaymentContext } from "@/features/accounts/payment/scraping/contexts/payment-context";

interface Props {
  onTapCloseModal: () => void;
  onTapCompleteModal: (paymentAccountId?: string) => void;
}

// スクレイピングログイン情報モーダル
export const PaymentLoginInfoModal = ({
  onTapCloseModal,
  onTapCompleteModal,
}: Props) => {
  const {
    selectedInstitutionService,
  } = useInstitutionsContext();
  const {
    openHomeModal,
  } = useModalContext();
  const { processType } = usePaymentContext();
  const {
    resetOtpContext,
  } = useOneTimePassContext();

  const {
    branchName,
    loginId1,
    loginId2,
    loginPwd1,
    loginPwd2,
    isActivateConfirmButton,
    onChangeBranchName,
    onChangeLoginId1,
    onChangeLoginId2,
    onChangeLoginPwd1,
    onChangeLoginPwd2,
    changeConfirmButtonState,
    onClickConfirm,
  } = usePaymentLoginInfo();

  useEffect(() => {
    changeConfirmButtonState();
  }, [branchName, loginId1, loginId2, loginPwd1, loginPwd2]);

  // 設定ボタンに付与するID
  const loginInfoSetting = "login_info_setting";

  return (
    <>
    { openHomeModal === "PaymentLoginInfo" && (
    <BasePageModal
      title="認証情報"
      // title={`${selectedInstitutionService?.companyName}のログイン情報入力`}
      className="md-list-authentication"
      disableOverlayClose={true}
      handleClose={() => {
        onTapCloseModal();
      }}
      bottomChildren={
        <>
          <BaseRoundButton
            buttonText="キャンセル"
            className="btn-cancel"
            loadingNegative={true}
            onClick={onTapCloseModal}
          />
          <BaseRoundButton
            buttonText="設定"
            onClick={async() => {
              if (selectedInstitutionService) {
                localStorage.setItem("companyName", selectedInstitutionService.companyName);
                localStorage.setItem("serviceName", selectedInstitutionService.serviceName);
                localStorage.setItem("branchName", selectedInstitutionService.branchName);
              }
              const res = await onClickConfirm(processType);
              if (res) {
                if (res.paymentAccountId !== "") {
                  onTapCompleteModal(res.paymentAccountId);
                }
              }
            }}
            id={loginInfoSetting}
            loadingNegative={true}
            isActive={isActivateConfirmButton}
          />
        </>
      }
    >
      <h2>{selectedInstitutionService?.companyName}のログイン情報を入力</h2>
      <blockquote className="fc_comment">
        <h4>{selectedInstitutionService?.companyName}</h4>
        <p>{selectedInstitutionService?.idInputComment}</p>
      </blockquote>
      <p>(*)は必ず入力してください</p>
      <ul>
        {(selectedInstitutionService && selectedInstitutionService?.branchName !== "") && (
          <li>
            <SimpleForm
              title={`${selectedInstitutionService?.branchNameInputTitle} ${selectedInstitutionService?.branchNameInputValidYn === "1" ? "(*)" : ""}`}
              onChange={onChangeBranchName}
              placeholder={`${selectedInstitutionService?.branchNameInputTitle} を入力`}
              labelEnable={true}
              validationRule=""
              maxLength={500}
            />
            </li>
        )}

        {selectedInstitutionService?.idInputYn === "1" && (
          <li>
            <SimpleForm
              title={`${selectedInstitutionService?.idInputTitle} ${selectedInstitutionService?.idInputValidYn === "1" ? "(*)" : ""}`}
              onChange={onChangeLoginId1}
              labelEnable={true}
              placeholder={`${selectedInstitutionService?.idInputTitle} を入力`}
              validationRule=""
              maxLength={500}
            />
          </li>
        )}

        {selectedInstitutionService?.id2InputYn === "1" && (
          <li>
            <SimpleForm
              title={`${selectedInstitutionService?.id2InputTitle} ${selectedInstitutionService?.id2InputValidYn === "1" ? "(*)" : ""}`}
              onChange={onChangeLoginId2}
              labelEnable={true}
              validationRule=""
              maxLength={500}
            />
          </li>
        )}
        
        {selectedInstitutionService?.pwdInputYn === "1" && (
          <li>
            <PasswordForm
              title={`${selectedInstitutionService?.pwdInputTitle} ${selectedInstitutionService?.pwdInputValidYn === "1" ? "(*)" : ""}`}
              placeholder={`${selectedInstitutionService?.pwdInputTitle} を入力`}
              onChange={onChangeLoginPwd1}
              validationRule=""
              maxLength={500}
            />
          </li>
        )}

        {selectedInstitutionService?.pwd2InputYn === "1" && (
          <li>
            <PasswordForm
              title={`${selectedInstitutionService?.pwd2InputTitle} ${selectedInstitutionService?.pwd2InputValidYn === "1" ? "(*)" : ""}`}
              placeholder={`${selectedInstitutionService?.pwd2InputTitle} を入力`}
              onChange={onChangeLoginPwd2}
              validationRule=""
              maxLength={500}
            />
          </li>
        )}
      </ul>

    </BasePageModal>
    )}
    { openHomeModal === "Otp" && (
      <OneTimePassModal
        processType={processType}
        onTapCloseModal={() => {
          resetOtpContext();
          onTapCloseModal();
        }}
        onTapCompleteModal={async () => {
          const res = await onClickConfirm(processType);
          if (res) {
            if (res.paymentAccountId !== "") {
              onTapCompleteModal(res.paymentAccountId);
            }
            // 新たにOTPが要求された場合はコンテキストをリセットしない
            // (リセットするとoneTimePassListが空になりレンダリングエラーになる)
            if (res.otpFlg !== "1") {
              resetOtpContext();
            }
          } else {
            resetOtpContext();
          }
        }}
      />
    )}
    </>
  );
};


/**
 * 確認用パスワード（pwdline1～pwdline5）について
 * 金融機関認証情報(追加)入力で使用。
 * https://gl.kuro.sorimachi.biz/mlink/moneylink/-/blob/main/IBPB/aag/AagBankAuthSecCardDlg.cpp?ref_type=heads#L537
 * 金融機関認証情報(追加)入力はlinkstorage.InstitutionService01.service_infoの sec_card_use_yn="1"の場合に表示される。
 * https://gl.kuro.sorimachi.biz/mlink/moneylink/-/blob/main/IBPB/aag/AagBankAuthInfoDlg.cpp?ref_type=heads#L699
 * 
 * 現状対象なし？（銀行口座で金融機関情報入力タイプのサービスはない認識）
 * https://teams.microsoft.com/l/message/19:b3acff8320b546729a5822891ade6f34@thread.tacv2/1761181712420?tenantId=a0d0e30d-892a-4e24-98ea-d97caf9d030a&groupId=a11f6956-29e1-4a41-b855-c49e8549b29d&parentMessageId=1761181712420&teamName=%E9%96%8B%E7%99%BA%E6%9C%AC%E9%83%A8%20%E5%85%B1%E6%9C%89%E7%AA%93%E5%8F%A3&channelName=%EF%BC%81%E6%9C%AC%E7%95%AA%E3%83%87%E3%83%BC%E3%82%BF%E5%8F%96%E5%BE%97&createdTime=1761181712420
 * 
 * この場合確認用パスワード（pwdline1～pwdline5）は実装の必要なし？
 * 
 * 
 * 同じく照会用暗証番号、電子証明書関連も対象なしで不要？
 * SELECT * FROM linkstorage.InstitutionService01 where service_info LIKE "%\"certificate_yn\": \"1\"%" AND service_code NOT REGEXP "^0[12][0-9]$";
 * -> 本番データ取得で対象はindustry_code="04"のみ。
 */